import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs,Switch } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import ActionForm from '../components/ActionForm';
import ActionUpdateForm from '../components/ActionUpdateForm';
import CommunicationTemplates from './CommunicationTemplates';


var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class ActionList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    actions: [],
    datarequested:true,

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/actions/`)
  .then(res => {
      this.setState({
        actions:res.data
      })
      this.setState({datarequested:false})
  })


}



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {
    const columns = [
    
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'id',
        ...this.getColumnSearchProps('name'),
      },
     
      {
        title: 'Type ',
        dataIndex: 'type_group',
        key: 'id',
        ...this.getColumnSearchProps('type_group'),
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'id',
      },
      {
        title: 'Auto triggered?',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
        <p>
          {record.auto_trigger===true?"Yes":"No"}
        </p>,
      },
     
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

          <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
             <TabPane tab={"Actions"} key="1">
                    <p>There are {this.state.actions.length} Actions in the list </p>
                      <Table 
                        columns={columns} 
                        scroll={{ x: 1000 }}
                        pagination={{showQuickJumper:true,showSizeChanger:true }}
                        dataSource={this.state.actions}
                        bordered
                        
                        expandable={{
                          expandedRowRender: (record) =>{
                              return (
                                <div>
                                  <Tabs
                                    defaultActiveKey="1"
                                    onChange={() => {}}
                                    tabPosition={'top'}
                                  >
                                  <TabPane tab={"Details/Update"} key="1">
                                    <ActionUpdateForm  action_obj={record} onRefresh={this.comp_reloaded} />
                                  </TabPane>


                                  {
                                    record.type_group==="Communication"?
                                    <TabPane tab={"Communication Templates"} key="2">
                                      <CommunicationTemplates actionobj={record} />
                                    </TabPane>

                                    :
                                    null
                                  }  
                                  

                                </Tabs>

                                </div>
                              );
                          } ,
                          rowExpandable: (record) => true,
                          onExpand:(condition,record)=>{
                          },
                        }}
                        
                        />
              </TabPane>

              <TabPane tab={"New Action"} key="2">
                <ActionForm onRefresh={this.comp_reloaded}/>
              </TabPane>

              </Tabs>

        </div>)

    }

   
  }
}

export default ActionList; 
